import OfferBox from "../components/offerBox";
import SideBar from "../components/sideBar";
import translateText, { currentLanguage } from "../signals/language.signal";

const Offer = () => {
  return (
    <div
      id="offerBox"
      className="align-items-sm-center d-flex  justify-content-center flex-column w-100"
    >
      <SideBar more={true} showAccount={true} title={translateText(currentLanguage.value, "OfferTitle")}/>
      <OfferBox />
  
    </div>
  );
};

export default Offer;
